// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5005) return "static/chunks/5005-5ff2fb879fdb3c2d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "8125760d78561dc0" + ".js";
};